module.exports = __webpack_public_path__ + "img/ltkbrasil-1x.0cb705f.jpg";